import { Button } from "@/components/ui/button";

const BookNowButton = () => {
  return (
    <div className="fixed top-4 right-4 z-[100]">
      <a
        href="https://na02.patientnow.com/a/EVOLVEDYOU"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          className="bg-red-500 hover:bg-red-600 text-white font-semibold px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
        >
          Book Now
        </Button>
      </a>
    </div>
  );
};

export default BookNowButton;